// 课堂评价
export default [
  {
    path: '/classevaluation/index',
    name: 'PageClassEvaluation',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/classevaluation/PageClassEvaluation'
      ),
    meta: {
      modular: 43,
      title: '课堂评价',
      info: '课堂评价——首页',
      keepAlive: true
    }
  },
  {
    path: '/classevaluation/list',
    name: 'PageClassEvaluationList',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/classevaluation/PageClassEvaluationList'
      ),
    meta: {
      modular: 43,
      title: '课堂评价',
      subTitle: '评价班级',
      info: '课堂评价——评价班级'
    }
  },
  {
    path: '/classevaluation/summary',
    name: 'PageClassEvaluationSummary',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/classevaluation/PageClassEvaluationSummary'
      ),
    meta: {
      modular: 43,
      title: '课堂评价',
      subTitle: '统计明细',
      info: '课堂评价——统计明细'
    }
  },
  {
    path: '/classevaluation/setting',
    name: 'PageClassEvaluationSetting',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/classevaluation/PageClassEvaluationSetting'
      ),
    meta: { modular: 43, title: '课堂评价', info: '课堂评价-设置' }
  },
  {
    path: '/classevaluation/export',
    name: 'PageClassEvaluationExport',
    component: () =>
      import(
        /* webpackChunkName: "classevaluation" */ '../pages/classevaluation/PageClassEvaluationExport'
      ),
    meta: {
      modular: 43,
      title: '报表导出',
      info: '课堂评价-导出',
      keepAlive: true
    }
  }
]
